// @flow
import grey from '@mui/material/colors/grey';

const drawerStyles = {
  root: (theme) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexAlign: 'flex-start',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '& a': {
      textDecoration: 'none'
    }
  }),

  itemTextCtr: (theme) => ({
    padding: '0 0'
  }),

  grow: (theme) => ({
    flexGrow: 1
  }),

  toolbarHeight: (theme) => ({
    height: theme.layout.customProps.header.height * 2,
    marginBottom: 0
  }),

  anchorTopRight: (theme) => ({
    transform: 'translate( 20%, -90%)'
  }),

  drawer: (theme) => ({
    width: theme.layout.customProps.drawer.width,
    display: { xs: 'none', sm: 'block' },
    flexShrink: { sm: 0 }
  }),

  menuLink: (theme) => ({
    textDecoration: 'none'
  }),

  drawerPaper: (theme) => ({
    width: theme.layout.customProps.drawer.width
  }),

  drawerPaperMobile: (theme) => ({
    width: theme.layout.customProps.drawer.width,
    zIndex: theme.zIndex.drawer + 2
  }),

  toolbar: (theme) => ({
    ...theme.mixins.toolbar,
    minHeight: `${theme.layout.customProps.header.height * 2}px !important`,
    [theme.breakpoints.down('xs')]: {
      minHeight: 'auto'
    }
  }),

  center: (theme) => ({
    textAlign: 'center',
    margin: '0 auto'
  }),

  noPadding: (theme) => ({
    paddingLeft: 0,
    paddingRight: 0
  }),

  footer: (theme) => ({
    textAlign: 'center',
    '& *': {
      color: theme.layout.customProps.gray
    }
  }),

  feedbackBtn: (theme) => ({
    margin: theme.spacing(1)
  }),

  input: (theme) => ({
    display: 'none'
  }),

  topCompanyIcon: (theme) => ({
    '& svg': {
      fontSize: 40,
      margin: '0 auto'
    }
  }),

  disabledItem: (theme) => ({
    '& *': {
      opacity: 0.75
    }
  }),

  upgradeBtn: (theme) => ({
    marginTop: theme.spacing(0.5),
    textTransform: 'none',
    borderRadius: 24
  }),

  rechargeBtn: (theme) => ({
    marginTop: theme.spacing(0.5),
    textTransform: 'none',
    borderRadius: 24,
    backgroundColor: 'white',
    color: 'black',
    '&:hover': {
      backgroundColor: '#EAEAEA'
    }
  }),

  upgradeItem: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(2)
    },
    '& p': {
      fontSize: '0.75rem',
      textAlign: 'center',
      lineHeight: '1rem',
      marginTop: theme.spacing(0.75),
      cursor: 'auto',
      maxWidth: '100%',
      wordWrap: 'break-word',
      overflow: 'hidden'
    }
  }),

  subListItem: (theme) => ({
    fontSize: '1rem',
    paddingLeft: theme.spacing(2.75),
    paddingRight: theme.spacing(2.75)
  }),

  listItem: (theme) => ({
    minWidth: theme.layout.customProps.drawer.width,
    maxWidth: theme.layout.customProps.drawer.width,
    boxSizing: 'border-box',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    '& div > span': {
      color: 'white'
    },
    '&:hover': {
      cursor: 'pointer'
    },
    [theme.breakpoints.down('sm')]: {
      height: theme.layout.customProps.toolbar.height
    }
  }),

  listItemSub: (theme) => ({
    paddingBottom: theme.spacing(3),
    justifyContent: 'center',
    '& *': {
      color: 'white'
    }
  }),

  listItemIcon: (theme) => ({
    display: 'inline-block',
    minWidth: 0
  }),

  menuRoot: (theme) => ({
    borderRadius: 0,
    backgroundColor: theme.palette.primary.main,
    left: `${theme.layout.customProps.drawer.width}px !important`
  }),

  menuItem: (theme) => ({
    height: 50
  }),

  subMenuListRoot: (theme) => ({
    paddingTop: 0,
    paddingBottom: 0,
    '& li': {
      color: 'white'
    }
  }),

  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    '& *': {
      color: 'white'
    }
  }),

  flexItem1: (theme) => ({
    flexGrow: 1,
    width: '100%',
    whiteSpace: 'nowrap'
  }),

  flexItem2: (theme) => ({
    marginLeft: -4,
    width: 24,
    paddingRight: theme.spacing(0.5)
  }),

  selected: (theme) => ({
    backgroundColor: theme.palette.custom.neoYellow.main,
    color: theme.palette.custom.neoViolet.dark,
    '&:hover': {
      backgroundColor: `${theme.palette.custom.neoYellow.dark} !important`
    },
    '& div > span': {
      color: theme.palette.custom.neoViolet.dark,
      fontWeight: 700
    }
  })
};

export default drawerStyles;